import { getEndpointV2 } from 'api';
import { fillPath } from 'helpers/api';

export const getPathToFetchAll = (): string => {
  return fillPath({ path: '/auth/company' });
};

/** */
export const getPathToFetchOne = (companyId: string): string => {
  return fillPath({ path: '/auth/company/:companyId', urlParams: { companyId } });
};

export const getUrlToFetchOne = (companyId: string): string => {
  return getEndpointV2({ path: getPathToFetchOne(companyId) });
};

/** */
